import GlobalRequest from './global-request';

const URL = 'v2/template/category';
const ASSESSMENT_CATEGORY_URL = 'v2/template/assessment/categories';

export default class CategoryApi {
    static async getAllCategories(company_id, assessment = false) {
        return await GlobalRequest.getRequest((assessment ? ASSESSMENT_CATEGORY_URL : URL) + '?company_id=' + company_id);
    }

    static async addCategory(body) {
        return await GlobalRequest.postRequest(URL, body);
    }

    static async updateCategory(id, body) {
        return await GlobalRequest.patchRequest(URL + '/' + id, body);
    }

    static async deleteCategory(id) {
        return await GlobalRequest.deleteRequest(URL + '/' + id);
    }
}
